<template>
    <div class="blog-post-page app-page">
        <v-progress-circular
                v-show="loadingArticle"
                class="blog-post__loading"
                :size="70"
                :width="7"
                color="green"
                indeterminate
        ></v-progress-circular>
        <div v-show="!newPost">
            <div v-show="!loadingArticle" class="blog-post__wrapper ck-content">
                <v-layout v-if="authorized" row  wrap>
                    <v-flex xs12>
                        <v-btn icon light @click.stop="deleteDialog = true">
                            <v-icon>delete_outline</v-icon>
                        </v-btn>
                        <v-btn icon light @click="$refs.postEditorInstance.toggleWritePost()">
                            <v-icon>edit</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>

                <div class="blog-post__article-text">
                    <h1 class="title font-weight-regular justify-space-between">
                        <h2>{{articleTitle}}</h2>
                    </h1>
                    <div>
                        <p class="blog-post__timestamp"><i>{{ createDate }}</i></p>
                        <v-divider class="blog-post__divider"></v-divider>
                        <p v-html="articleBody"></p>
                        <v-divider class="blog-post__divider"></v-divider>
                        <div class="blog-post__author-details">
                            <div class="blog-post__author-details-content">
                                <v-avatar color="grey lighten-4" size="100">
                                    <v-img v-if="photoURL" :src="photoURL + '?x=' + Date.now()">
                                        <template v-slot:placeholder>
                                            <v-layout fill-height align-center justify-center ma-0>
                                                <v-progress-circular indeterminate color="grey"></v-progress-circular>
                                            </v-layout>
                                        </template>
                                    </v-img>
                                    <span v-else></span>
                                </v-avatar>
                                <div>
                                    <h3>{{displayName}}</h3>
                                    <p v-html="userDescription"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="clear: both"></div>
                </div>
            </div>
        </div>
        <PostEditor
            v-bind:editPostData="postData"
            v-bind:docId="docId"
            v-bind:author="author"
            ref="postEditorInstance"
            v-if="authorized"
            v-on:toggle-post="newPost = $event">
        </PostEditor>

        <v-dialog v-if="authorized"  v-model="deleteDialog" max-width="290">
            <v-card>
                <v-card-title class="headline">Dzēst rakstu?</v-card-title>
                <v-card-text>
                    Raksts tiks neatgriezeniski dzēsts.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text small @click="deleteDialog = false">
                        Atcelt
                    </v-btn>

                    <v-btn dark small color="red" @click="deletePost">
                        <v-icon>delete_outline</v-icon> Dzēst
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import PostEditor from '../components/PostEditor';

    import firebase from 'firebase/app'
    import firebaseCfg from "../firebaseConfig"

    export default {
        name: "BlogPost",
        components: { PostEditor },
        data() {
            return {
                newPost: false,
                authorized: false,
                loadingArticle: true,
                deleteDialog: false,

                author: '',
                photoURL: null,
                displayName: null,
                userDescription: null,

                docId: '',
                articleTitle: '',
                articleBody: '',
                createDate: '',

                postData: null
            }
        },
        methods: {
            deletePost: function(){
                const that = this;

                firebaseCfg.db.collection("posts").doc(that.docId).delete().then(function() {
                    that.$router.push('/zinas');
                }).catch(function(error) {
                    alert("kļūda dzēšot: ", error);
                });
            },
            getProfileData: function(){
                const that = this;

                firebaseCfg.db.collection("users").doc(that.author).get().then(function(userDBData){
                    if(userDBData.exists){
                        userDBData = userDBData.data();
                        that.photoURL = userDBData.photoURL;
                        that.displayName = userDBData.displayName;
                        that.userDescription = userDBData.userDescription;

                        that.loadingArticle = false;
                    } else {
                        that.loadingArticle = false;
                    }
                });

            },
        },
        mounted() {
            const that = this;

            firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                    that.authorized = true;
                } else {
                    that.authorized = false;
                }
            });

            firebaseCfg.db.collection("posts").doc(that.$route.params.id).get().then(function(document){
                if(document.exists){
                    const article = document.data();

                    const fullDate = article.createDate.toDate();
                    const time = fullDate.toLocaleTimeString("lv", { hour: '2-digit', minute: '2-digit' });
                    const date = fullDate.toLocaleDateString("lv", { year: 'numeric', month: 'short', day: 'numeric' } );

                    that.postData = article;

                    that.docId = document.id;
                    that.author = article.author;
                    that.articleTitle = article.title;
                    that.articleBody = article.text;
                    that.createDate = date + ' ' + time;

                    that.getProfileData();
                }
            })
        }
    }
</script>
<style>
    a {
        color: #529A18;
    }
    a:hover{ color: #88DE19 }
    .blog-post__img-centering {
        display: block;
        max-width: 100%;
        margin-left: auto;
        margin-right: auto;
    }
    .blog-post__article-text figcaption a {
        text-decoration: none;
        color: #79c616;
    }
</style>
<style scoped>
    .blog-post-page {
        height: 100%;
        padding: 120px 25px 100px;
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .blog-post__loading {
        margin: 0 auto;
    }
    .blog-post__wrapper {
        width: 100%;
        max-width: 720px;
        margin: 0 auto;
    }
    .blog-post__divider {
        margin: 10px 0 25px;
    }
    .blog-post__article-text p{
        font-size: 17px;
        line-height: 24px;
        color: #272727;
        font-family: Helvetica, Georgia, serif;
    }
    .blog-post__timestamp i {
        font-size: 14px;
    }
    .blog-post__author-details { margin: 25px 0; }
    .blog-post__author-details-content {
        display: flex;
        flex-direction: row;
    }
    .blog-post__author-details-content .v-avatar { margin-right: 20px; }
    .blog-post__author-details-content h3 { margin-bottom: 15px; }
</style>